import Backbone from 'backbone'
import Thresholds from 'scoreboard/components/threshold-colors/thresholds'
import gradients from './gradients'
import _ from 'lodash'
import unwrapModel from '../unwrap-model'

const ThresholdColors = Backbone.Model.extend({

	defaults: {
		'gradientType': 'segmented',
		'segments' : 6,
		'reversed' : false,
		'gradient' : gradients.ids()[13]
	},

	initialize(attrs, options = {}) {
		let thresholds = this.get('thresholds') || []
		let { min, max } = this.attributes

		this._thresholdValues = new Thresholds(
			{ thresholds, min, max, segments : this.get('segments') })
		this.on('change:thresholds change:segments', (m, value) => {
			this._thresholdValues.resize(value)
		})
		this.on('change:thresholds', (m, value) => {
			this._thresholdValues.resize(this.numThresholds())
		})
	},

	numThresholds: function() {
		let { segments, gradientType } = this.attributes
		return gradientType == 'continuous' ? segments : segments+1
	},

	computedThresholds: function() {
		return this._thresholdValues.values()
	},

	/**
	 * Returns each of the color sections threshold values as well as the color
	 * that corresponds to that section
	 */
	getSectionsToColors: function() {
		const thresholds = this.computedThresholds()
		const opacity = .5

		let data = []
		_.each(thresholds, (value, i) => {
			if (i == _.size(thresholds) - 1) return
			data.push({
				thresholdPair: [value, thresholds[i + 1]],
				color: this.color(value, opacity).formatHex()
			})
		})

		// if the thresholds are equal, there is only a single value
		const firstDatum = data[0].thresholdPair
		if (firstDatum[0] == firstDatum[1]) data = [data[0]]

		// filter out the ranges that no values fit into
		data = _.filter(data, d => {
			const { min, max } = unwrapModel(this)
			const values = d.thresholdPair

			const beneathRange = values[1] < min
			const aboveRange = values[0] > max
			return !beneathRange && !aboveRange
		})
		return data
	},

	/**
	 * @return {String[]} the colors for each section
	 */
	getColors: function() {
		return this.getSectionsToColors().map(datum => datum.color)
	},

	color: function(value, opacity) {
		let { gradient, gradientType, reversed } = this.attributes
		let data = gradients.byId(gradient)
		let gradientData
		if (gradientType == 'continuous') {
			gradientData = data.continuous(reversed)
		} else {
			gradientData = data.discrete(this.computedThresholds(), reversed)
		}
		return gradientData.valueToColor(value, { opacity })
	}

})

export default ThresholdColors
ThresholdColors.__filename__ = 'components/threshold-colors/threshold-colors-model.js'
